module.exports = __webpack_public_path__ + "smartphone.bace856bc4fa5b8032f58f1dcd065dfe.svg";